const API_URL = process.env.REACT_APP_API_URL;
// const API_URL = "http://localhost:5000/api";

export default API_URL;
